import React from 'react'
import BottomSheetLoader from '@component/core/BottomSheetLoader'
import IntercomSetting from '@lib/IntercomSetting'

interface IProps {
    className?: string
}

const BottomSheetArea: React.FC<IProps> = ({className}) => {
    return (
        <div className={'w-full fixed bottom-0 flex flex-col items-end z-tooltip'}>
            <IntercomSetting />
            <BottomSheetLoader />
        </div>
    )
}
export default BottomSheetArea
